import React, { Fragment, memo, useState, useEffect } from "react";
import SvgClose from "../../assets/icons/SvgClose";
import SvgLocation from "../../assets/icons/SvgLocation";
import countriesBgImg from "../../assets/images/topbar-background.webp";
import { useStaticQuery, graphql } from "gatsby";
import { getCurrencySymbol } from "../../utils/getCurrencySymbol";
import { getLocationUrl } from "../../utils/getLocation";

const ACTIVE_LOCALE = process.env.GATSBY_LOCALE_CURRENCY;
function Country() {
  const { allContentfulDomain } = useStaticQuery(graphql`
    {
      allContentfulDomain {
        nodes {
          title
          isoCode
          currencyCode
          url
        }
      }
    }
  `);

  const locations = allContentfulDomain.nodes;
  const [selectedLocation, setSelectedLocation] = useState(
    locations.find((node) => node.currencyCode === ACTIVE_LOCALE)
  );
  const [locationLinks, setLocationLinks] = useState([]);

  useEffect(() => {
    setLocationLinks(locations.map((location) => {
      return {
        ...location,
        url: getLocationUrl(location.url),
      }
    }));
  }, [locations])

  const [isOpen, setOpen] = useState(false);

  return (
    <Fragment>
      {selectedLocation && (
        <button
          className="text-xs leading-3 tracking-wide cursor-pointer flex gap-1 items-center"
          role="button"
          onClick={() => setOpen(true)}
        >
          <SvgLocation width="16px" height="16px" />
          {selectedLocation.title} ({selectedLocation.currencyCode})
        </button>
      )}
      <div
        className={`fixed left-0 w-screen h-screen bg-white transition-all duration-300 ease-in-out ${
          isOpen ? "top-0" : "-top-[100vh]"
        }`}
      >
        <div className="lg:px-[30px] py-[10px] text-[#1A202C]">
          <div
            className="relative py-9 px-[30px] lg:px-[90px] bg-left bg-no-repeat bg-contain w-full"
            style={{
              backgroundImage: `url(${countriesBgImg})`,
            }}
          >
            <div className="flex justify-end relative">
              <div
                className="absolute top-0 -right-[5%] rounded-full w-8 h-8 cursor-pointer items-center flex justify-center hover:text-secondary-500"
                onClick={() => setOpen(false)}
              >
                <SvgClose width="14px" height="14px" />
              </div>
            </div>
            <h2 className="pb-[30px] font-bold tracking-wide leading-8 text-3xl mt-14">
              Select your location
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-3">
              {locationLinks.map((location, index) => (
                <a
                  className="mb-5 group"
                  key={index}
                  href={location.url}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                  }}
                >
                  <div
                    className="flex text-xs font-bold leading-[21px] tracking-wide hover:underline-offset-[6px] hover:text-secondary-500"
                    onClick={() => setSelectedLocation(location)}
                  >
                    <p className="text-black flex gap-1 text-inherit items-center group-hover:underline">
                      <SvgLocation
                        width="16px"
                        height="16px"
                        style={{ marginBottom: "4px" }}
                      />
                      {location.title}
                      <span>
                        <span>
                          (
                          {`${location.currencyCode} 
                          ${getCurrencySymbol(
                            location.isoCode,
                            location.currencyCode
                          )}
                          `}
                          )
                        </span>
                      </span>
                    </p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default memo(Country);
